export default "<div class=\"container-fluid\">\r\n  <router-outlet></router-outlet>\r\n</div>\r\n"